/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, codec: NonNullable<unknown> }} Audio_Embed_Export_Stream_VideoInputs */

const en_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video ${i?.index}: ${i?.codec}`)
};

const fr_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vidéo ${i?.index}: ${i?.codec}`)
};

const de_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video ${i?.index}: ${i?.codec}`)
};

const it_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video ${i?.index}: ${i?.codec}`)
};

const ru_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Видео ${i?.index}: ${i?.codec}`)
};

const es_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vídeo ${i?.index}: ${i?.codec}`)
};

const zh_cn2_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`视频 ${i?.index}: ${i?.codec}`)
};

const ja_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ビデオ ${i?.index}: ${i?.codec}`)
};

const hi_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वीडियो ${i?.index}: ${i?.codec}`)
};

const pt_pt2_audio_embed_export_stream_video = /** @type {(inputs: Audio_Embed_Export_Stream_VideoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vídeo ${i?.index}: ${i?.codec}`)
};

/**
* | output |
* | --- |
* | "Video {index}: {codec}" |
*
* @param {Audio_Embed_Export_Stream_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_stream_video = /** @type {((inputs: Audio_Embed_Export_Stream_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Stream_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_stream_video(inputs)
	if (locale === "de") return de_audio_embed_export_stream_video(inputs)
	if (locale === "it") return it_audio_embed_export_stream_video(inputs)
	if (locale === "ru") return ru_audio_embed_export_stream_video(inputs)
	if (locale === "es") return es_audio_embed_export_stream_video(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_stream_video(inputs)
	if (locale === "ja") return ja_audio_embed_export_stream_video(inputs)
	if (locale === "hi") return hi_audio_embed_export_stream_video(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_stream_video(inputs)
	return en_audio_embed_export_stream_video(inputs)
});